import React from "react";
import { Link } from "gatsby";
import kubeLogo from "../images/kube/kube-logo.svg";

export default function Navbar({ hasSubNav }) {
  const brandImg = hasSubNav ? "dripstat-logo-black" : "logo-color";

  const navStyle = { paddingTop: "0.5rem", paddingBottom: "0.5rem" };
  let loginStyle;
  if (hasSubNav) {
    navStyle.backgroundColor = "#F8F8F8";
    loginStyle = {
      backgroundColor: "#F8F8F8",
    };
  }

  return (
    <nav className="navbar mainNavbar" style={navStyle}>
      <div className="container">
        <div className="navbar-brand">
          <Link className="navbar-item" to="/">
            <img src={`/img/${brandImg}.png`} alt="Dripstat" className="navlogoImg" />
          </Link>
        </div>
        <div className="navbar-menu">
          <div className="navbar-start">
            <Link className="navbar-item" to="/">
              Home
            </Link>
            <div className="navbar-item has-dropdown is-hoverable">
              {/*eslint-disable-next-line*/}
              <a className="navbar-link">Products</a>

              <div className="navbar-dropdown is-boxed">
                <Link className="navbar-item" to="/products/apm/">
                  <img src="/img/apm-black.png" className="navDropdownImg" alt="" /> <span className="navDropdownText">Application Performance Monitoring</span>
                </Link>
                <Link className="navbar-item" to="/products/infra">
                  <img src="/img/infra-black.png" className="navDropdownImg" alt="" /> <span className="navDropdownText">Infrastructure Monitoring</span>
                </Link>
                <Link className="navbar-item" to="/products/kubernetes">
                  <img src={kubeLogo} className="navDropdownImg" alt="" /> <span className="navDropdownText">Kubernetes Monitoring</span>
                </Link>

                <div className="navbar-item dividerTitle">Product Features</div>
                <hr className="navbar-divider" />
                <Link className="navbar-item" to="/alerts">
                  <img src="/img/alerts.png" className="navDropdownImg" alt="" />
                  <span className="navDropdownText">Alerts</span>
                </Link>
              </div>
            </div>

            <div className="navbar-item has-dropdown is-hoverable">
              {/*eslint-disable-next-line*/}
              <a className="navbar-link">Pricing</a>

              <div className="navbar-dropdown is-boxed">
                <Link className="navbar-item" to="/products/apm/pricing/">
                  <img src="/img/apm-black.png" className="navDropdownImg" alt="" /> <span className="navDropdownText">Application Performance Monitoring</span>
                </Link>
                <Link className="navbar-item" to="/products/infra/pricing/">
                  <img src="/img/infra-black.png" className="navDropdownImg" alt="" /> <span className="navDropdownText">Infrastructure Monitoring</span>
                </Link>
                <Link className="navbar-item" to="/products/kubernetes/pricing/">
                  <img src={kubeLogo} className="navDropdownImg" alt="" /> <span className="navDropdownText">Kubernetes Monitoring</span>
                </Link>
              </div>
            </div>
          </div>

          <div className="navbar-end">
            <div className="navbar-item">
              <Link className="button is-white" to="/login" style={loginStyle}>
                Log in
              </Link>
            </div>
            <div className="navbar-item">
              <Link className="button is-primary is-fullwidth navSignupBtn" to="/signup">
                Sign Up
              </Link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
